import { CabinI, MyMscExcursion } from '@msc-b2c/interfaces/interfaces';
import { SelectedDayFilter } from '@msc-b2c/interfaces/types';

const hasExcursionInventory = (exc: MyMscExcursion): boolean =>
  Number(exc.inventory?.numberAvailable) > 0;

export const isExcursionVisibleOnAllPortsView = (
  exc: MyMscExcursion,
  cabinLoggedUser: CabinI
): boolean => {
  const { departureDate, arrivalDate } = cabinLoggedUser.cruise;

  return (
    (departureDate !== exc.startDate &&
      arrivalDate !== exc.startDate &&
      !exc.code.endsWith('E') &&
      !exc.code.endsWith('D')) ||
    (arrivalDate === exc.startDate && exc.code.endsWith('D')) ||
    (departureDate === exc.startDate && (exc.code.endsWith('E') || exc.isPackage))
  );
};

/** Same embark/disembark rules as results when "all ports" is selected (e.g. product carousel). */
export const filterExcursionsForAllPortsView = (
  excursions: MyMscExcursion[],
  cabinLoggedUser: CabinI | undefined
): MyMscExcursion[] => {
  if (!cabinLoggedUser) {
    return [];
  }

  return excursions.filter(
    (exc) => hasExcursionInventory(exc) && isExcursionVisibleOnAllPortsView(exc, cabinLoggedUser)
  );
};

export const filterMyAreaExcursionsByDay = (
  excursions: MyMscExcursion[],
  selectedDay: SelectedDayFilter | undefined,
  cabinLoggedUser: CabinI | undefined,
  disableEmbarkAndDisembarkExcursions: boolean
): MyMscExcursion[] => {
  if (!excursions.length) {
    return excursions;
  }

  if (
    selectedDay?.date !== 'allPorts' &&
    selectedDay?.portCode !== 'SEA' &&
    !selectedDay?.isEmbarkationDay &&
    !selectedDay?.isDisembarkationDay
  ) {
    return excursions.filter(
      (exc) =>
        exc.startDate === selectedDay?.date &&
        exc.portCode === selectedDay?.portCode &&
        hasExcursionInventory(exc) &&
        !exc.code.endsWith('D') &&
        !exc.code.endsWith('E')
    );
  }

  if (selectedDay?.date !== 'allPorts' && selectedDay?.isEmbarkationDay) {
    return excursions.filter(
      (exc) =>
        (exc.isPackage && hasExcursionInventory(exc)) ||
        (exc.code.endsWith('E') &&
          exc.startDate === selectedDay?.date &&
          exc.portCode === selectedDay?.portCode &&
          !disableEmbarkAndDisembarkExcursions &&
          hasExcursionInventory(exc))
    );
  }

  if (
    !disableEmbarkAndDisembarkExcursions &&
    selectedDay?.date !== 'allPorts' &&
    selectedDay?.isDisembarkationDay
  ) {
    return excursions.filter(
      (exc) =>
        exc.code.endsWith('D') &&
        exc.startDate === selectedDay?.date &&
        exc.portCode === selectedDay?.portCode &&
        hasExcursionInventory(exc)
    );
  }

  if (selectedDay?.portCode === 'SEA') {
    return excursions.filter(
      (exc) =>
        exc.startDate === selectedDay?.date &&
        exc.portCode === 'ATC' &&
        hasExcursionInventory(exc) &&
        !exc.code.endsWith('D') &&
        !exc.code.endsWith('E')
    );
  }

  if (excursions.length > 0) {
    return filterExcursionsForAllPortsView(excursions, cabinLoggedUser);
  }

  return excursions;
};
